import { useState } from "react";
import ModalSys from "../modal";
import { Grid, Typography } from "@mui/material";
import CardSys from "../cardSys";
import ButtonOk from "../buttonOk";
import ButtonConsultLogs from "../buttonConsultLog";
import ButtonTryAgain from "../buttonTryAgain";
import { useNavigate } from "react-router-dom";

export default function SyncSucessModules({ handleClose }) {
  const [modal, setModal] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <CardSys sx={{ display: "flex", justifyContent: "center" }}>
        <Grid container>
          <Typography sx={{ textAlign: "center", margin: "40px" }}>
            Sincronização realizada com sucesso
          </Typography>
        </Grid>
        <Grid sx={{ display: "flex", justifyContent: "center",gap:"20px" }}>
            <ButtonConsultLogs onClick={() => navigate("/logs")}></ButtonConsultLogs>
            <ButtonTryAgain onClick={handleClose}>Ok</ButtonTryAgain>
        </Grid>
      </CardSys>
    </>
  );
}
